export const isMiniTokenEnabled = process.env.REACT_APP_MINITOKEN_ENABLED === 'true'

export const isMoonPayEnabled = process.env.REACT_APP_ENABLE_MOONPAY !== 'mainnet'
export const moonPayMode = process.env.REACT_APP_NETWORK_ENV === 'mainnet' ? 'production' : 'test'
export const moonPayApiKey =
  moonPayMode === 'production'
    ? 'pk_live_AezjYN2UJghXHVXoWH6oFFE3kBI37p'
    : 'pk_test_OZksbXGh4UvoO9zxDKS9IpbGVSZke4h'

export const signMoonPayUrlEndpoint =
  moonPayMode === 'production'
    ? 'https://wallet.binance.org/api/v1/moonpay/sign'
    : 'https://testnet-wallet.binance.org/api/v1/moonpay/sign'
